<template>
  <NotFoundError>
    <template #hat="{ hat }">
      <p class="text-h1">
        {{ hat }}
      </p>
    </template>
  </NotFoundError>
</template>

<script setup lang="ts">
import { NotFoundError } from "@pasta/box-v2";
</script>
